import { useFeatureFlags } from '@atlassian/mpac-ui';
import React from 'react';
import PartnerHeader from "../../common/components/PartnerHeader";
import Tabs from "../../common/components/Tabs";
import PartnerAdmin from "../PartnerAdmin";
import PartnerContacts from "../PartnerContacts";
import PartnerPaymentInfo from "../PartnerPaymentInfo";
import PartnerProfile from "../PartnerProfile";
import Promotions from "../Promotions";
import { getTabs, TabNames } from "./utils";

const ManagePartners = props => {
  const TabComponents = {
    [TabNames.DETAILS]: PartnerProfile,
    [TabNames.CONTACTS]: PartnerContacts,
    [TabNames.PROMOTIONS]: Promotions,
    [TabNames.ADMIN]: PartnerAdmin,
    [TabNames.PAYMENT_INFO]: PartnerPaymentInfo
  };
  const TabComponent = TabComponents[props.selectedTab];
  const {
    managePartnerSpaTabs
  } = useFeatureFlags();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PartnerHeader, {
    mpacBaseUrl: props.mpacBaseUrl,
    partnerDetails: props.partnerDetails,
    partnerId: props.partnerId,
    showPartnerActions: true,
    isSiteAdmin: props.permissions.isSiteAdmin
  }), /*#__PURE__*/React.createElement(Tabs, {
    tabs: getTabs(props.partnerId, props.permissions, managePartnerSpaTabs),
    selectedTab: props.selectedTab
  }), /*#__PURE__*/React.createElement(TabComponent, {
    partnerId: props.partnerId,
    mpacBaseUrl: props.mpacBaseUrl
  }));
};

export default ManagePartners;